(() => {
  const refresh = () => {
    const groups = [...document.querySelectorAll('[data-friends-group]')];
    document.querySelectorAll('[data-friends-nav]').forEach((nav) => {
      nav.replaceChildren(...groups.map((group) => {
        const link = document.createElement('a');
        link.href = `#${group.id}`;
        link.textContent = group.dataset.friendsLabel;
        return link;
      }));
      nav.hidden = groups.length === 0;
    });
  };
  if (!window.tcsFriendsNavigation) {
    window.tcsFriendsNavigation = true;
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((event) => document.addEventListener(event, () => requestAnimationFrame(refresh)));
  }
  refresh();
})();
